import React from "react";
import {
  Box,
  Typography,
  Container as MuiContainer,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { FeatureCard } from "./FeatureCard";

export const FeaturesSection = ({
  learnGroupImage,
  teachingImage,
  chatImage,
  logoImage,
}) => {
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));

  const features = [
    {
      image: learnGroupImage,
      imageAlt: "Learning Groups - Studenten arbeiten zusammen in einer Lerngruppe",
      title: "...trete einer Lerngruppe bei, oder gründe eine neue!",
      highlightedText: "Lerngruppe",
      imagePosition: "left",
    },
    {
      image: teachingImage,
      imageAlt: "Nachhilfe - Studenten geben und nehmen Nachhilfe",
      title: "...nimm Nachhilfe! Oder, verdiene dir etwas dazu und gebe selbst Nachhilfe! Egal ob Student, Alumni, oder einfach nur top in speziellen Bereichen.",
      highlightedText: "Nachhilfe",
      imagePosition: "right",
    },
    {
      image: chatImage,
      imageAlt: "Chat App - Einfache Kommunikation über unseren Chat",
      title: "Und das alles ganz einfach über unseren Chat. Auch auf deinem Smartphone!",
      highlightedText: "Chat",
      imagePosition: "left",
      showLogo: true,
      logoImage,
    },
  ];

  return (
    <Box sx={{ 
      py: { xs: 6, md: 10 }, 
      backgroundColor: '#fafafa',
      width: '100%',
      maxWidth: '100vw',
      overflow: 'hidden'
    }}>
      <MuiContainer 
        maxWidth="lg"
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          width: '100%',
          maxWidth: '100%',
        }}
      >
        <Typography
          variant="h4"
          component="h2"
          sx={{
            textAlign: 'center',
            mb: { xs: 4, md: 6 },
            color: muiTheme.palette.grey[800],
            fontWeight: 600,
          }}
        >
          Wähle deinen Uni-Kurs und...
        </Typography>

        {features.map((feature, index) => (
          <Box key={index} sx={{ position: 'relative' }}>
            <FeatureCard
              image={feature.image}
              imageAlt={feature.imageAlt}
              title={feature.title}
              highlightedText={feature.highlightedText}
              imagePosition={feature.imagePosition}
              isMobile={isMobile}
            />
            
            {/* Logo - only visible on desktop for chat feature */}
            {feature.showLogo && !isMobile && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  right: '-50px',
                  transform: 'translateY(-50%)',
                  zIndex: 1,
                }}
              >
                <img
                  src={feature.logoImage}
                  alt="Blag Logo"
                  loading="lazy"
                  style={{
                    width: '80px',
                    height: '80px',
                    opacity: 0.8,
                  }}
                />
              </Box>
            )}
          </Box>
        ))}
      </MuiContainer>
    </Box>
  );
};
